import { Injectable } from '@angular/core';

import { AppConfiguration } from 'src/app/appConfiguration.class';

@Injectable()
export class Configurations {
  appConfiguration: AppConfiguration = new AppConfiguration();
}
